import React from 'react';

const SafeIcon = ({ icon: Icon, className, style }) => {
  if (!Icon) {
    console.warn('SafeIcon: No icon provided');
    return null;
  }
  
  return <Icon className={className} style={style} />;
};

export default SafeIcon;